/**
 * Prevent the OS from sleeping while the app runs.
 * Chromium can deadlock on sleep/wake; best fix is to never sleep.
 * Uses chrome.power (available in NW.js app context on both old and new NW).
 */
export const startKeepAwake = () => {
    if (typeof global === 'undefined') {
        return;
    }
    try {
        const chromeApi = (window as any).chrome;
        if (chromeApi?.power?.requestKeepAwake) {
            // 'display' = keep system AND display awake (most aggressive)
            chromeApi.power.requestKeepAwake('display');
            console.log('keepAwake: requestKeepAwake(display) ok');
        } else {
            console.warn('keepAwake: chrome.power not available');
        }
    } catch (error) {
        console.warn('keepAwake failed:', error);
    }
};
